import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { Avatar, Stack } from '@mui/material';
import { EmployeeToBusiness, LoadedUser, ModalData } from '../../interfaces';
import { createModalData } from '../modal/employeeModal';
import {
  getPayoutText,
  getSelectedRolesFromEmployee,
} from '../../helpers/employees';
import { HeaderCells } from '../../types/ui';
import { convertSnakeToTitleCase } from '../global/helper';

export const headerCells = [
  { id: 'Name', label: 'Name' },
  { id: 'Job', label: 'Job' },
  { id: 'Status', label: 'Status' },
  { id: 'Payee', label: 'Payee' },
  { id: 'View Employee', label: '' },
] as const satisfies HeaderCells;

// Function to create a table row from an employee data
export function createRow({
  currentUser,
  employee,
  handleClick,
}: {
  currentUser: LoadedUser;
  employee: EmployeeToBusiness;
  handleClick: (newModalData: ModalData, employee: EmployeeToBusiness) => void;
}) {
  const newModalData = createModalData(currentUser, employee) as ModalData;

  const cleanedRole = employee.user
    ? getSelectedRolesFromEmployee(employee.user.role, employee)
        .map(convertSnakeToTitleCase)
        .join(', ')
    : '-';

  const names = (
    employee.user?.firstName
      ? [employee.user?.firstName, employee.user?.lastName]
      : [employee?.displayName]
  ).filter(Boolean) as string[];
  const initials = names.map(name => name.charAt(0).toUpperCase()).join('');

  const payoutText = getPayoutText(employee);

  const row = {
    rowId: employee.employeeId,
    cells: [
      <Stack direction="row" gap={2} alignItems="center">
        <Avatar
          sx={{
            width: 32,
            height: 32,
            backgroundColor: employee.color,
            boxSizing: 'border-box',
            p: 1,
            fontSize: theme => theme.typography.body2.fontSize,
          }}>
          {initials}
        </Avatar>
        <Typography variant="body1">
          {employee.user?.firstName} {employee.user?.lastName}
        </Typography>
      </Stack>,
      <Typography variant="body1">{cleanedRole}</Typography>,
      <Typography variant="body1">
        {employee.user?.authServiceId ? 'Active' : 'Invited'}
      </Typography>,
      <Typography variant="body1">{payoutText}</Typography>,
      <Button
        onClick={() => handleClick(newModalData, employee)}
        variant="outlined"
        className="table-button">
        View Employee
      </Button>,
    ],
  };

  return row;
}
